import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "rich-content",
      innerHTML: $props.html,
      onClick: $setup.open
    }, null, 8 /* PROPS */, _hoisted_1),
    ($setup.images.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "image-lightbox",
          onClick: _cache[3] || (_cache[3] = _withModifiers($event => ($setup.images=[]), ["self"]))
        }, [
          _createElementVNode("button", {
            class: "lightbox-close",
            onClick: _cache[0] || (_cache[0] = $event => ($setup.images=[]))
          }, "×"),
          ($setup.images.length>1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "lightbox-prev",
                onClick: _cache[1] || (_cache[1] = $event => ($setup.index=($setup.index-1+$setup.images.length)%$setup.images.length))
              }, "‹"))
            : _createCommentVNode("v-if", true),
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              src: $setup.images[$setup.index].src,
              alt: $setup.images[$setup.index].alt
            }, null, 8 /* PROPS */, _hoisted_2),
            _createElementVNode("figcaption", null, [
              _createTextVNode(_toDisplayString($setup.images[$setup.index].alt) + " · " + _toDisplayString($setup.index+1) + "/" + _toDisplayString($setup.images.length) + " ", 1 /* TEXT */),
              _createElementVNode("a", {
                href: $setup.images[$setup.index].src,
                target: "_blank"
              }, "Открыть оригинал", 8 /* PROPS */, _hoisted_3)
            ])
          ]),
          ($setup.images.length>1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "lightbox-next",
                onClick: _cache[2] || (_cache[2] = $event => ($setup.index=($setup.index+1)%$setup.images.length))
              }, "›"))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}